export default __webpack_public_path__ + "static/media/logo-loader.dce89f20.png";